import React from 'react';
import './termsAndConditions.style.scss';
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';

const Privacy = () => {

    const date = 'September 10, 2024'

    return (
        <div>

            {/* Navbar */}
            <div className='section'>
                <Navbar />
            </div>

            {/* Main Section */}
            <div
                className='section text-section tight terms'
                style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}
            >
                <h1 style={{ color: 'var(--fontlightblack1)' }}>Privacy Notice for Reach</h1>
                <p style={{ textAlign: 'left' }}>Last Updated: <strong>{date}</strong></p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>1. Introduction</h2>
                <p>This Privacy Notice explains how Reach collects, uses, and protects your personal data when you use our platform. By using Reach, you consent to the collection and processing of your information as described in this notice.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>2. Information We Collect</h2>
                <ul>
                    <li><strong>Account Information:</strong> When you sign up, we collect your email, name, and profile information.</li>
                    <li><strong>Usage Data:</strong> We collect data on how you interact with the platform, such as challenges you browse, complete, or schedule.</li>
                    <li><strong>Device Information:</strong> Reach may collect data on the device and network you use to access the platform, such as IP addresses and browser types.</li>
                    <li><strong>Cookies and Tracking:</strong> We use cookies to improve your experience and understand platform usage.</li>
                </ul>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>3. How We Use Your Information</h2>
                <ul>
                    <li><strong>To Provide the Service:</strong> We use your data to operate the platform, including scheduling challenges, tracking your progress, and managing your account.</li>
                    <li><strong>To Improve Reach:</strong> We analyze usage data to improve features and enhance your user experience.</li>
                    <li><strong>Marketing and Communication:</strong> If you opt-in, we may send you emails and notifications about new challenges, updates, or promotions.</li>
                </ul>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>4. Sharing Your Information</h2>
                <ul>
                    <li><strong>With Influencers and Educators:</strong> We may share aggregated or anonymized data with influencers and educators to help them understand how users engage with their challenges.</li>
                    <li><strong>With Service Providers:</strong> We use third-party service providers to help operate the platform (e.g., cloud services, payment processors). These providers are contractually obligated to protect your data.</li>
                    <li><strong>Firebase:</strong> We use Firebase, a cloud-based service provided by Google, for data storage, authentication, and other backend services. Firebase may collect data such as IP addresses, device information, and usage data. Firebase complies with strict security and privacy standards to protect your information. You can learn more about Firebase's data handling by reviewing <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase's Privacy Policy</a>.</li>
                    <li><strong>Legal Obligations:</strong> We may disclose your information if required by law or in response to legal requests.</li>
                </ul>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>5. Your Rights</h2>
                <ul>
                    <li><strong>Access:</strong> You can request a copy of your personal data.</li>
                    <li><strong>Correction:</strong> You can request corrections to inaccurate or incomplete information.</li>
                    <li><strong>Deletion:</strong> You can request that we delete your personal data, subject to any legal requirements.</li>
                    <li><strong>Opt-Out:</strong> You may unsubscribe from marketing communications at any time.</li>
                </ul>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>6. Data Security</h2>
                <p>We take reasonable steps to protect your data from unauthorized access or misuse. However, no internet service can be entirely secure, so we encourage you to take precautions.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>7. Retention of Information</h2>
                <p>We retain your information for as long as necessary to provide the service and meet legal obligations. You may request deletion of your data at any time, and we will process this request unless we are required to retain it by law.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>8. Changes to This Privacy Notice</h2>
                <p>We may update this Privacy Notice periodically. We will notify you of any significant changes.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>9. Contact Us</h2>
                <p>If you have any questions about this Privacy Notice or how your data is handled, please contact us <a href="/contact" target="_blank" rel="noopener noreferrer">here</a>.</p>
            </div>

            {/* Footer Margin */}
            <div className="footer-margin">
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Privacy;